<template>
    <div class="timeline-group" :class="{'timeline-group--year-marker': hasYearMarker}">
        <span v-if="hasYearMarker" class="divider has-or divider--timeline-year">{{yearLabel}}</span>
        <div class="grid-fitted grid-unstackable">
            <div class="grid-item no-flex">
                <v-icon class="inline-s" icon="calendar"/>
            </div>
            <div class="grid-item">
                <h3 class="text-left"><span class="has-tooltip text-left" :data-tooltip="tooltip">{{dateLabel}}</span>
                </h3>
            </div>
        </div>
    </div>
</template>

<script>
    import {vIcon} from '@/components/form';
    import {DateTimeFormats} from '@/common/datetime-formats';

    export default {
        name: 'group-header',
        components: {vIcon},
        props: {
            date: Number,
            count: Number,
            hasYearMarker: Boolean, // render the year line
        },
        computed: {
            yearLabel() {
                return this.$tz().readUTC(this.date).year();
            },
            dateLabel() {
                const today = this.$tz().now().startOf('day').valueOf();
                const groupDate = this.$filters.dateUTC(this.date, DateTimeFormats.timelineHeader);
                if (today === this.date) {
                    return `Today, ${groupDate}`;
                }
                return groupDate;
            },
            tooltip() {
                return this.$filters.dateUTC(this.date, DateTimeFormats.date);
            },
        },
    };
</script>

<style>
    .timeline-group--year-marker {
        border-top: none;
        position: relative;
        text-align: center;
    }

    .divider.divider--timeline-year {
        position: absolute;
        left: 0;
        top: -32px;
        top: -3.2rem;
        right: 0;
    }

    .divider.divider--timeline-year:before,
    .divider.divider--timeline-year:after {
        border-top: 1px dashed #C4CED8;
    }
</style>
